

// #region Browser

export function getUrlParam()
{
    const queryString = window.location.search;

    // parse the query string's paramters
    const urlParams = new URLSearchParams(queryString);

    return urlParams.get('productid');
}

export function navigateToPage(url)
{
    if (url) 
    {
        window.open(url, '_blank', 'noopener,noreferrer')
    }
}

// #endregion Browser

//#region String

export function isString(value)
{
    // type checking
    if (typeof value === 'string' || value instanceof String)
        return true;
    else
        return false;
}

export function isJsonString(value)
{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
}

export function tryJsonParse(value) 
{
    try {
        return JSON.parse(value);
    } catch (error) {
        return null;
    }
}
//#endregion String
